<template>
  <div class="page">
    <van-cell-group>
      <!-- <input v-model="name" type="text" placeholder="请输入微信用户名"> -->
      <input v-model="phone" type="text" placeholder="请输入手机号" />
      <input v-model="pwd" type="password" placeholder="请输入密码" />
      <van-button type="primary" round block @click="login">登录</van-button>
      <div class="foot">
        <span class="regist" @click="toregist">注册账号</span>
        <span class="forget" @click="toforget">忘记密码</span>
      </div>
    </van-cell-group>
    <p
      style="position: absolute; bottom: 10px; width: 100%; text-align: center"
    >
      <a style="color: #61dec3" href="https://beian.miit.gov.cn/"
        >闽ICP备20012852号-1</a
      >
    </p>
  </div>
</template>

<script>
import API from "../utils/api";

export default {
  data: function () {
    return {
      name: "",
      phone: "",
      pwd: "",
    };
  },
  methods: {
    login() {
      if (this.phone == "" || this.pwd == "") {
        this.$toast("请输入完整信息");
        return;
      }
      this.$post(
        `${API.userLogin}?phone=${this.phone}&pwd=${this.pwd}&openId=${sessionStorage.getItem("openid")}`
      )
        .then((res) => {
          if (res.code == 200) {
            sessionStorage.clear();
            sessionStorage.setItem("token", res.data.token);
            sessionStorage.setItem("nick", res.data.name);
            sessionStorage.setItem("phone", this.phone);
            sessionStorage.setItem("icon", res.data.icon);
            if (res.data.icCard) {
              sessionStorage.setItem("card", res.data.icCard);
            }
            this.$router.push({ path: `index` });
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toregist() {
      this.$router.push({ path: `regist` });
    },
    toforget() {
      this.$router.push({ path: `forget` });
    },
    getOpen() {
      if (!sessionStorage.getItem("openid")) {
        if (
          this.$route.query.code != "" &&
          this.$route.query.code != undefined
        ) {
          this.$post(
            `/fn_callback.php?code=${this.$route.query.code}`,
            { code: this.$route.query.code }
          )
            .then((res) => {
              sessionStorage.setItem("openid", res.openid);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.$post(`/login2.php`)
            .then((res) => {
              if (res.code == 1) {
                location.href = res.data;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  },
  created() {
    this.getOpen();
  },
  mounted() {},
  computed: {},
};
</script>
<style scoped>
.page {
  background: linear-gradient(top, #61dec3, #fff);
  background: url(/static/img/bgindex.png) no-repeat 50%;
  background-size: 100% 100%;
  min-height: 100vh;
  width: 100%;
}
.van-cell-group {
  position: absolute;
  top: 45%;
  left: 5%;
  right: 5%;
  background: none;
}
.van-hairline--top-bottom::after {
  border: none;
}
.van-cell-group input {
  width: 100%;
  background: #fafafa;
  margin-bottom: 20px;
  padding: 0 15px;
  height: 44px;
  line-height: 44px;
  border-radius: 100px;
}
.van-cell-group input::placeholder {
  color: #ccc;
}
.van-cell-group .van-button--primary {
  background-color: #61dec3;
  border: 1px solid #61dec3;
  font-size: 16px;
}
.van-cell-group .foot {
  display: flex;
  width: 50%;
  margin: auto;
  margin-top: 20px;
}
.van-cell-group .foot span {
  flex: 1;
  text-align: center;
  font-size: 14px;
}
.van-cell-group .foot .regist {
  color: #61dec3;
  border-right: 1px solid #ccc;
}
.van-cell-group .foot .forget {
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue